import { Pipe, PipeTransform } from '@angular/core';
import { ScTableColumn } from '../../../../models/table.model';

@Pipe({
  name: 'colClass'
})
export class ColClassPipe implements PipeTransform {
  transform(col: ScTableColumn, row: any): string[] {
    if (typeof col.class === 'function') {
      return col.class(row);
    }
    return col.class;
  }
}
